import { Option } from "../generics/Select/Option";
import { PortalActions, sortPortals } from "../state";
import { PortalSortMethods } from "../state/utils/sort";

export function useSelect(
  sortedBy: PortalSortMethods,
  dispatch: React.Dispatch<PortalActions>
): [
  string | undefined,
  Option<PortalSortMethods>[],
  (newOption: Option<PortalSortMethods>) => void
] {
  const onValueChanged = (newOption: Option<PortalSortMethods>): void => {
    dispatch(sortPortals(newOption.value));
  };

  const selectOptions: Option<PortalSortMethods>[] = [
    {
      label: "Alfabetisk",
      value: PortalSortMethods.LEXICOGRAPHIC,
    },
    {
      label: "Niveau",
      value: PortalSortMethods.GRADE_LEVEL,
    },
  ];

  const label = selectOptions.find((it) => it.value === sortedBy)?.label;

  return [label, selectOptions, onValueChanged];
}
